import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OnboardingProcess } from 'src/app/models/state/onboarding-process-state.model';

export const OnboardingProcessActions = createActionGroup({
	source: 'OnboardingProcess',
	events: {
		'Go Next Process': props<{ canSkipNextProcess: boolean }>(),
		'Go Previous Process': props<{ canSkipNextProcess: boolean }>(),
		'Load Processes': props<{ processes: Array<OnboardingProcess> }>(),
		'Reset Process': emptyProps(),
		'Add Total Steps': props<{ totalSteps: number }>(),
		'Update onboarding Progress': props<{
			processes: Array<OnboardingProcess>;
			canSkipStepNextStep: boolean;
		}>(),
		/** Alinea el proceso actual con la ruta a la que ya navegó el router. */
		'Sync Process With Route': props<{
			route: string;
			canSkipNextProcess: boolean;
		}>(),
	},
});
